// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonCol,
  IonGrid,
  IonRow,
} from "@ionic/react"
import { TrackableDocument } from "../api"
import { PurchaseOrderLines } from "./PurchaseOrderLines"


interface ContainerProps {
  document: TrackableDocument
}


const AcceptDocument: React.FC<ContainerProps> = ({
  document
}) => {
  return (
    <IonGrid className="pt-0" style={{display: "flex", flexDirection: "column", overflowY: "scroll"}}>
      <IonRow>
        <IonCol
          size="12"
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "0px",
            maxHeight: "var(--section-body-height)",
            overflowY: "hidden"
          }}
        >
          <PurchaseOrderLines order={document}/>
        </IonCol>
      </IonRow>
    </IonGrid>
  )
}

export {AcceptDocument};